import React, { useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "./../PurchaseRequest.css";
import ApproveModal from './../../../../Components/Modals/ApproveModal';
import NoDataImg from "../../../../Assets/Images/no-data-img.png";
import Moment from "moment";
import TableTemp from "../../../../Components/TableTemplate/Table";
// import PaymentTable from './../../../Components/TableTemplate/PaymentTable';
import AddNoteModal from './AddNoteModal';
// import AddPaymentModal from './AddPaymentModal';
import { getPurchaseRequest } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi";
import Navbar from "../../../../Components/Navbar/Navbar";
import Footer from "../../../../Components/Footer/Footer";

export default function ViewPurchaseRequest() {
    const { id } = useParams();
    let navigate = useNavigate();

    const [inactive, setInactive] = useState(true);
    const [items, setItems] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [notes, setNotes] = useState([{
        details: "sample",
        added_by_name: "Mark Lee"
    }]);
    const [addDetails, setAddDetails] = useState({})
    /* print modal handler */
    const [showPrintModal, setShowPrintModal] = useState(false);
    const handleShowPrintModal = () => setShowPrintModal(true);
    const handleClosePrintModal = () => setShowPrintModal(false);
    // create po modal
    const [showCreatePOModal, setShowCreatePOModal] = useState(false);
    const handleShowCreatePOModal = () => setShowCreatePOModal(true);
    const handleCloseCreatePOModal = () => setShowCreatePOModal(false);
    // Add note modal
    const [showAddNoteModal, setShowAddNoteModal] = useState(false);
    const handleShowAddNoteModal = () => setShowAddNoteModal(true);
    const handleCloseAddNoteModal = () => setShowAddNoteModal(false);
    /* add payment modal handler */
    const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
    const handleShowAddPaymentModal = () => setShowAddPaymentModal(true);
    const handleCloseAddPaymentModal = () => setShowAddPaymentModal(false);
    const [balance, setBalance] = useState("");

    async function fetchPurchaseRequest() {
        const response = await getPurchaseRequest({id: id});
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data;
                return info
            })
            setAddDetails(data[0]);

            var itemsdata = data[0].purchase_request_items.map((data) => {
                var info = data;
                info.item_id_value = {
                    label: data.item_name,
                    value: data.item_id,
                }
                return info
            })
            setItems(itemsdata);
            setNotes(data[0].purchase_request_notes)
        }
    }

    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>quantity</th>
                        <th>unit</th>
                        <th>name</th>
                        <th>price</th>
                        <th>remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td>{item.quantity}</td>
                                <td>{item.unit}</td>
                                <td>{item.description}</td>
                                <td>{item.price}</td>
                                <td>{item.remarks}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    React.useEffect(() => {
        fetchPurchaseRequest(id);
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                    setInactive(inactive);
                    }}
                    active={"PURCHASES"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
                
                <Row className="mb-4">
                    <Col xs={12} lg={9}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> VIEW PURCHASE REQUEST </h1>
                    </Col>
                    <Col xs={12} lg={3}>
                        <span className="PI-header2">PURCHASE REQUEST NO. {id}</span>
                    </Col>
                </Row>

                <div className="review-form mb-3">
                    <Container fluid>
                        <Row className="review-container py-3">
                            <Row>
                                <Col>
                                    <span className="review-label nc-modal-custom-row print-label">
                                        Department Name
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row print-label">
                                        Branch
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row print-label">
                                        Request Date
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row print-label">
                                        Required Date
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span className="review-data print-data">
                                        {addDetails.department_name}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data print-data">
                                        {addDetails.branch}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data print-data">
                                        {Moment(addDetails.request_date).format("MMM DD, YYYY")}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data print-data">
                                        {Moment(addDetails.required_date).format("MMM DD, YYYY")}
                                    </span>
                                </Col>
                            </Row>
                        </Row>
                        <Row className="review-container py-3">
                            <Row>
                                <Col>
                                    <span className="review-label nc-modal-custom-row print-label">
                                        Requested By
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row print-label">
                                        Remarks
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span className="review-data print-data">
                                        {addDetails.requested_by}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data print-data">
                                        {addDetails.remarks}
                                    </span>
                                </Col>
                            </Row>
                        </Row>
                    </Container>

                    {/* INVOICES */}
                    <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            APPLIED TO THE FOLLOWING INVOICES
                        </span>
                        <div className="review-purchased-items">
                            {renderTable()}
                        </div>
                    </div>
                    <div className="d-flex mt-5 mb-2 justify-content-evenly">
                        <div className="print-table mt-3 mx-2 print-data">
                            ATTACHMENT/S
                            {addDetails.purchase_request_attachments ? (
                                <>
                                {addDetails.purchase_request_attachments.map((data) => {
                                    if(data.base_64 !== "") {
                                        return(
                                            <>
                                                <div className='mt-5 mb-2' style={{textAlignLast:"center"}}><img src={`data:image/png;base64,${data.base_64}`} width={400} height={400}/></div>
                                                {/* <div className='d-flex justify-content-center my-4'>
                                                    <button
                                                        className="button-primary"
                                                        onClick={()=>handleShowViewModal(data.base_64)}
                                                    >
                                                        View
                                                    </button>
                                                </div> */}
                                            </>
                                        )
                                    } else {
                                        return(
                                            <>
                                                <div className="no-data-cont">
                                                    <div className='mt-5 mb-2' style={{textAlignLast:"center"}} alt="no data found"><img src={NoDataImg} width={400} height={400}/></div>
                                                    <span>Uh Oh! No data found.</span>
                                                </div>
                                            </>
                                        )
                                    }
                                })}
                                </>
                            ) : (
                                <div className="no-data-cont">
                                    <div className='mt-5 mb-2' style={{textAlignLast:"center"}} alt="no data found"><img src={NoDataImg} width={400} height={400}/></div>
                                    <span>Uh Oh! No data found.</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <Container
                        fluid
                        className="PI-payment-info-wrapper mt-5 py-3 px-3"
                    >
                        {
                            addDetails.status === "approved" && (
                                <>
                                    <h5 className="PI-payment-info">NOTES</h5>
                                    <div className="justify-content-center">
                                        <TableTemp
                                            tableHeaders={[
                                                "DETAILS",
                                                "ADDED BY",
                                            ]}
                                            headerSelector={[
                                                "details",
                                                "added_by_name",
                                            ]}
                                            tableData={notes}
                                        />
                                    </div>
                                </>
                            )
                        }
                        {/* {
                            addDetails.status === "generated" && (
                                <>
                                    <h5 className="PI-payment-info">PAYMENT INFO</h5>
                                    <div className="justify-content-center">
                                        <PaymentTable
                                            tableHeaders={[
                                                "PAYMENT DATE",
                                                "TYPE",
                                                "DETAILS",
                                                "AMOUNT",
                                            ]}
                                            headerSelector={[
                                                "payment_date",
                                                "type",
                                                "details",
                                                "amount",
                                            ]}
                                            // tableData={notes}
                                        />
                                    </div>
                                </>
                            )
                        } */}
                    </Container>

                    {
                        addDetails.status === "approved" && (
                            <>
                                <div className="d-flex justify-content-end pt-5">
                                    <button
                                        type="button"
                                        className="button-secondary me-3"
                                        onClick={() =>
                                            navigate("/purchaserequests")
                                        }
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="button-tertiary me-3"
                                        onClick={handleShowAddNoteModal}
                                    >
                                        Add Note
                                    </button>
                                    <button
                                        type="button"
                                        className="button-primary me-3"
                                        onClick={handleShowCreatePOModal}
                                    >
                                        Create PO
                                    </button>
                                </div>
                            </>
                        )
                    }
                    {
                        addDetails.status === "generated" && (
                            <>
                                <div className="d-flex justify-content-end pt-5">
                                    <button
                                        type="button"
                                        className="button-secondary me-3"
                                        onClick={() =>
                                            navigate("/purchaserequests")
                                        }
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="button-tertiary me-3"
                                        onClick={handleShowPrintModal}
                                    >
                                        Print
                                    </button>
                                    <button
                                        type="button"
                                        className="button-primary me-3"
                                        onClick={handleShowAddPaymentModal}
                                    >
                                        Add Payment
                                    </button>
                                </div>
                            </>
                        )
                    }
                    {
                        addDetails.status !== "generated" && addDetails.status !== "approved" && (
                            <>
                                <div className="d-flex justify-content-end pt-5">
                                    <button
                                        type="button"
                                        className="button-secondary me-3"
                                        onClick={() =>
                                            navigate("/purchaserequests")
                                        }
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="button-tertiary me-3"
                                        onClick={handleShowPrintModal}
                                    >
                                        Print
                                    </button>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
            
            <ApproveModal
                show={showCreatePOModal}
                hide={handleCloseCreatePOModal}
                type="approve"
                text="create this request as PO"
                page="transaction"
                handler={() => navigate("/purchaseorders/add/" + id)}
                isClicked={isClicked}
            />

            <ApproveModal
                show={showPrintModal}
                hide={handleClosePrintModal}
                type="approve"
                text="print this purchase request"
                page="transaction"
                handler={() => navigate("/purchaserequests/print/" + id)}
                isClicked={isClicked}
            />
            
            <AddNoteModal
                id={id}
                show={showAddNoteModal}
                hide={handleCloseAddNoteModal}
                type="approve"
                // handler={handlePrintPI}
            />

            {/* <AddPaymentModal
                id={id}
                balance={balance}
                show={showAddPaymentModal}
                onHide={handleCloseAddPaymentModal}
            /> */}
            <Footer/>
        </div>
    );
}
